import {configureStore} from '@reduxjs/toolkit';
import userReducer from './reducers/userReducer';
import {cryptoApi} from '../services/cryptoAPI';
import {cryptoNewsApi} from '../services/cryptoNewsAPI';
import {BBFinanceAPI} from '../services/BBFinanceAPI';
import {portfolioApi} from '../services/PortfolioApi';
import StockReducer from './reducers/StockReducer';
import authReducer from './reducers/authReducer';
import portfolioReducer from './reducers/portfolioReducer';

const store = configureStore({
    reducer: {
        [cryptoApi.reducerPath]: cryptoApi.reducer,
        [cryptoNewsApi.reducerPath]: cryptoNewsApi.reducer,
        [BBFinanceAPI.reducerPath]: BBFinanceAPI.reducer,
        [portfolioApi.reducerPath]: portfolioApi.reducer,
        user: userReducer,
        stocks: StockReducer,
        portfolio: portfolioReducer,
        auth: authReducer,
    }
})

export default store;
